import { SurveyForm } from "./SurveyForm";

import { BooleanField, StringArrayField, StringField } from "@/core/fields";

export class UpperExamSurveyForm extends SurveyForm {
  public question1 = false;
  public question2: string[] = [];
  public question3: string | undefined = undefined;
  public question4: string | undefined = undefined;
  public question5: string | undefined = undefined;
  public question6: string | undefined = undefined;
  public question7: string[] = [];
  public question8: string | undefined = undefined;
  public question9: string | undefined = undefined;
  public question10 = false;
  public question11: string[] = [];
  public question12: string[] = [];
  public question13: string[] = [];
  public question14: string[] = [];
  public question15: string[] = [];
  public question16: string | undefined = undefined;
  public question17: string | undefined = undefined;
  public question18 = false;
  public question19: string[] = [];
  public question20: string[] = [];
  public question21: string | undefined = undefined;
  public question22: string | undefined = undefined;
  public question23: string[] = [];
  public question24: string[] = [];
  public question25: string[] = [];
  public question26: string[] = [];
  public question27: string | undefined = undefined;
  public question28: string | undefined = undefined;

  public constructor(firestoreData?: Record<string, unknown>) {
    super(firestoreData);
    if (firestoreData !== undefined) this.fromFirestore(firestoreData);

    this.isPrintable = true;
  }

  public fromFirestore(data: Record<string, unknown>): UpperExamSurveyForm {
    super.fromFirestore(data);

    this.question1 = BooleanField.fromFirestore(data.question1);
    this.question2 = StringArrayField.fromFirestore(data.question2);
    this.question3 = StringField.fromFirestore(data.question3);
    this.question4 = StringField.fromFirestore(data.question4);
    this.question5 = StringField.fromFirestore(data.question5);
    this.question6 = StringField.fromFirestore(data.question6);
    this.question7 = StringArrayField.fromFirestore(data.question7);
    this.question8 = StringField.fromFirestore(data.question8);
    this.question9 = StringField.fromFirestore(data.question9);
    this.question10 = BooleanField.fromFirestore(data.question10);
    this.question11 = StringArrayField.fromFirestore(data.question11);
    this.question12 = StringArrayField.fromFirestore(data.question12);
    this.question13 = StringArrayField.fromFirestore(data.question13);
    this.question14 = StringArrayField.fromFirestore(data.question14);
    this.question15 = StringArrayField.fromFirestore(data.question15);
    this.question16 = StringField.fromFirestore(data.question16);
    this.question17 = StringField.fromFirestore(data.question17);
    this.question18 = BooleanField.fromFirestore(data.question18);
    this.question19 = StringArrayField.fromFirestore(data.question19);
    this.question20 = StringArrayField.fromFirestore(data.question20);
    this.question21 = StringField.fromFirestore(data.question21);
    this.question22 = StringField.fromFirestore(data.question22);
    this.question23 = StringArrayField.fromFirestore(data.question23);
    this.question24 = StringArrayField.fromFirestore(data.question24);
    this.question25 = StringArrayField.fromFirestore(data.question25);
    this.question26 = StringArrayField.fromFirestore(data.question26);
    this.question27 = StringField.fromFirestore(data.question27);
    this.question28 = StringField.fromFirestore(data.question28);

    return this;
  }

  public toFirestore(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toFirestore();

    firestoreData.question1 = BooleanField.toFirestore(this.question1);
    firestoreData.question2 = StringArrayField.toFirestore(this.question2);
    firestoreData.question3 = StringField.toFirestore(this.question3);
    firestoreData.question4 = StringField.toFirestore(this.question4);
    firestoreData.question5 = StringField.toFirestore(this.question5);
    firestoreData.question6 = StringField.toFirestore(this.question6);
    firestoreData.question7 = StringArrayField.toFirestore(this.question7);
    firestoreData.question8 = StringField.toFirestore(this.question8);
    firestoreData.question9 = StringField.toFirestore(this.question9);
    firestoreData.question10 = BooleanField.toFirestore(this.question10);
    firestoreData.question11 = StringArrayField.toFirestore(this.question11);
    firestoreData.question12 = StringArrayField.toFirestore(this.question12);
    firestoreData.question13 = StringArrayField.toFirestore(this.question13);
    firestoreData.question14 = StringArrayField.toFirestore(this.question14);
    firestoreData.question15 = StringArrayField.toFirestore(this.question15);
    firestoreData.question16 = StringField.toFirestore(this.question16);
    firestoreData.question17 = StringField.toFirestore(this.question17);
    firestoreData.question18 = BooleanField.toFirestore(this.question18);
    firestoreData.question19 = StringArrayField.toFirestore(this.question19);
    firestoreData.question20 = StringArrayField.toFirestore(this.question20);
    firestoreData.question21 = StringField.toFirestore(this.question21);
    firestoreData.question22 = StringField.toFirestore(this.question22);
    firestoreData.question23 = StringArrayField.toFirestore(this.question23);
    firestoreData.question24 = StringArrayField.toFirestore(this.question24);
    firestoreData.question25 = StringArrayField.toFirestore(this.question25);
    firestoreData.question26 = StringArrayField.toFirestore(this.question26);
    firestoreData.question27 = StringField.toFirestore(this.question27);
    firestoreData.question28 = StringField.toFirestore(this.question28);

    return firestoreData;
  }

  public fromOfflineCache(data: Record<string, unknown>): UpperExamSurveyForm {
    super.fromOfflineCache(data);

    this.question1 = BooleanField.fromOfflineCache(data.question1);
    this.question2 = StringArrayField.fromOfflineCache(data.question2);
    this.question3 = StringField.fromOfflineCache(data.question3);
    this.question4 = StringField.fromOfflineCache(data.question4);
    this.question5 = StringField.fromOfflineCache(data.question5);
    this.question6 = StringField.fromOfflineCache(data.question6);
    this.question7 = StringArrayField.fromOfflineCache(data.question7);
    this.question8 = StringField.fromOfflineCache(data.question8);
    this.question9 = StringField.fromOfflineCache(data.question9);
    this.question10 = BooleanField.fromOfflineCache(data.question10);
    this.question11 = StringArrayField.fromOfflineCache(data.question11);
    this.question12 = StringArrayField.fromOfflineCache(data.question12);
    this.question13 = StringArrayField.fromOfflineCache(data.question13);
    this.question14 = StringArrayField.fromOfflineCache(data.question14);
    this.question15 = StringArrayField.fromOfflineCache(data.question15);
    this.question16 = StringField.fromOfflineCache(data.question16);
    this.question17 = StringField.fromOfflineCache(data.question17);
    this.question18 = BooleanField.fromOfflineCache(data.question18);
    this.question19 = StringArrayField.fromOfflineCache(data.question19);
    this.question20 = StringArrayField.fromOfflineCache(data.question20);
    this.question21 = StringField.fromOfflineCache(data.question21);
    this.question22 = StringField.fromOfflineCache(data.question22);
    this.question23 = StringArrayField.fromOfflineCache(data.question23);
    this.question24 = StringArrayField.fromOfflineCache(data.question24);
    this.question25 = StringArrayField.fromOfflineCache(data.question25);
    this.question26 = StringArrayField.fromOfflineCache(data.question26);
    this.question27 = StringField.fromOfflineCache(data.question27);
    this.question28 = StringField.fromOfflineCache(data.question28);

    return this;
  }

  public toOfflineCache(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toOfflineCache();

    firestoreData.question1 = BooleanField.toOfflineCache(this.question1);
    firestoreData.question2 = StringArrayField.toOfflineCache(this.question2);
    firestoreData.question3 = StringField.toOfflineCache(this.question3);
    firestoreData.question4 = StringField.toOfflineCache(this.question4);
    firestoreData.question5 = StringField.toOfflineCache(this.question5);
    firestoreData.question6 = StringField.toOfflineCache(this.question6);
    firestoreData.question7 = StringArrayField.toOfflineCache(this.question7);
    firestoreData.question8 = StringField.toOfflineCache(this.question8);
    firestoreData.question9 = StringField.toOfflineCache(this.question9);
    firestoreData.question10 = BooleanField.toOfflineCache(this.question10);
    firestoreData.question11 = StringArrayField.toOfflineCache(this.question11);
    firestoreData.question12 = StringArrayField.toOfflineCache(this.question12);
    firestoreData.question13 = StringArrayField.toOfflineCache(this.question13);
    firestoreData.question14 = StringArrayField.toOfflineCache(this.question14);
    firestoreData.question15 = StringArrayField.toOfflineCache(this.question15);
    firestoreData.question16 = StringField.toOfflineCache(this.question16);
    firestoreData.question17 = StringField.toOfflineCache(this.question17);
    firestoreData.question18 = BooleanField.toOfflineCache(this.question18);
    firestoreData.question19 = StringArrayField.toOfflineCache(this.question19);
    firestoreData.question20 = StringArrayField.toOfflineCache(this.question20);
    firestoreData.question21 = StringField.toOfflineCache(this.question21);
    firestoreData.question22 = StringField.toOfflineCache(this.question22);
    firestoreData.question23 = StringArrayField.toOfflineCache(this.question23);
    firestoreData.question24 = StringArrayField.toOfflineCache(this.question24);
    firestoreData.question25 = StringArrayField.toOfflineCache(this.question25);
    firestoreData.question26 = StringArrayField.toOfflineCache(this.question26);
    firestoreData.question27 = StringField.toOfflineCache(this.question27);
    firestoreData.question28 = StringField.toOfflineCache(this.question28);

    return firestoreData;
  }
}
